import { getLogger } from '../logging/logger';

export function setupShutdownHandler(
  onShutdown: () => Promise<void>,
): void {
  let shuttingDown = false;

  const handler = (signal: string): void => {
    const logger = getLogger();

    if (shuttingDown) {
      logger.warn('Forced shutdown', { signal });
      process.exit(1);
    }

    shuttingDown = true;
    logger.info('Shutting down...', { signal });

    onShutdown()
      .then(() => {
        process.exit(0);
      })
      .catch((err) => {
        logger.error('Shutdown error', {
          error: err instanceof Error ? err.message : String(err),
        });
        process.exit(1);
      });
  };

  process.on('SIGINT', () => handler('SIGINT'));
  process.on('SIGTERM', () => handler('SIGTERM'));
}
